import * as _ from 'underscore';
import { TYPES as PROGRAM_TYPES } from '../../../state/reducer/calendar/programTypes';

export default class ActionBarOptions {
    constructor(sessions, programType) {
        this.sessions = sessions;
        this.programType = programType;
    }

    includesSubscription = () => {
        return _.any(
            this.sessions,
            session => session.data.program_type === PROGRAM_TYPES.CALENDAR
        );
    };

    isProgramFixedLength = () => this.programType === PROGRAM_TYPES.FIXED;

    isProgramExportEnabled = () => {
        if (this.isProgramFixedLength()) return false;
        return !this.includesSubscription();
    };

    isAtLeastOneSessionPublished = () =>
        _.any(this.sessions, session => session.data.published);

    isAtLeastOneSessionUnpublished = () =>
        _.any(this.sessions, session => !session.data.published);

    isPublishEnabled = () => {
        if (this.isProgramFixedLength()) return false;
        if (this.includesSubscription()) return false;
        return this.isAtLeastOneSessionUnpublished();
    };

    isUnpublishEnabled = () => {
        if (this.isProgramFixedLength()) return false;
        if (this.includesSubscription()) return false;
        return this.isAtLeastOneSessionPublished();
    };
}



// WEBPACK FOOTER //
// ./src/state/reducer/clipboard/actionBarOptions.js